module.exports = "https://r.nearpod.com/assets/media/image/office-icon-6d804cab47d83774517362ade42d6574.svg";